// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "p[data-v-7f963cc8]{text-align:left}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/component_quotes/components/MatterProductSearchResult.vue"],"names":[],"mappings":"AACA,mBACC,eAAA","file":"MatterProductSearchResult.vue","sourcesContent":["\np {\n\ttext-align: left\n}\n"]}]);
// Exports
module.exports = exports;
